export enum FontWeight {
  Regular = 400,
  Semibold = 600
}
